<template>
  <div @click="onClick" class="tabs-item" :class="isActive" :data-name="name">
      <slot></slot>
  </div>
</template>

<script>
export default {
    name: 'g-tabs-head-item',
    inject:['eventBus'],
    props: {
        name:{
            type: String | Number,
            required: true
        },
        disabled:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            active: false
        }
    },
    created() {
        this.eventBus && this.eventBus.$on('update:selected', (name) => {
            this.active = this.name === name
        })
    },
    methods: {
        onClick() {
            if(this.disabled){
                return
            }
            this.eventBus && this.eventBus.$emit('update:selected', this.name,this)
            this.$emit('click', this)
        }
    },
    computed: {
        isActive(){
            return {
                active: this.active,
                disabled: this.disabled
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../var';
.tabs-item{
    padding:0 1em;
    height:100%;
    cursor: pointer;
    &.active{
        color:$blue;
        font-weight: bold;
    }
    &.disabled{
        color:#ddd;
        cursor: not-allowed;
    }
}
</style>